import moment, { Moment } from "moment"

export class ChatMessageTypes {
  static readonly HELP: string = "help"
  static readonly CHECK: string = "check"
  static readonly HAND_DOWN: string = "hand_down"
  static readonly MESSAGE: string = "message"

  static readonly ALL: string[] = [
    ChatMessageTypes.HELP,
    ChatMessageTypes.CHECK,
    ChatMessageTypes.HAND_DOWN,
    ChatMessageTypes.MESSAGE,
  ]
}

// eslint-disable-next-line import/no-default-export
export default class ChatMessage {
  timestamp?: Moment

  constructor(
    public id: string,
    public type: ChatMessageTypes,
    public userId: string,
    public displayName: string,
    public text: string,
    timestampStr?: string,
  ) {
    this.timestamp = timestampStr ? moment(timestampStr) : undefined
  }

  get isCheck(): boolean {
    return this.type === ChatMessageTypes.CHECK
  }

  get isHelp(): boolean {
    return this.type === ChatMessageTypes.HELP
  }

  get isHandDown(): boolean {
    return this.type === ChatMessageTypes.HAND_DOWN
  }

  get isMessage(): boolean {
    return this.type === ChatMessageTypes.MESSAGE
  }
}
